import { render, staticRenderFns } from "./pwa_group_translates.vue?vue&type=template&id=6ea60c20&scoped=true&"
import script from "./pwa_group_translates.vue?vue&type=script&lang=js&"
export * from "./pwa_group_translates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ea60c20",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ea60c20')) {
      api.createRecord('6ea60c20', component.options)
    } else {
      api.reload('6ea60c20', component.options)
    }
    module.hot.accept("./pwa_group_translates.vue?vue&type=template&id=6ea60c20&scoped=true&", function () {
      api.rerender('6ea60c20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/catalog/news/modal/group/tabs/pwa_group_translates.vue"
export default component.exports